import { ReactNode } from 'react';
import Header from '../feature/Header';
import Footer from '../feature/Footer';

interface CalculatorLayoutProps {
  children: ReactNode;
}

export default function CalculatorLayout({ children }: CalculatorLayoutProps) {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-28">{children}</main>
      <Footer />
    </div>
  );
}
